import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  MdEmail,
  MdPhone,
  MdLocationOn,
  MdSend,
  MdPerson,
  MdMessage,
} from "react-icons/md";
import {
  FaTwitter,
  FaFacebook,
  FaWhatsapp,
  FaLinkedin,
  FaGithub,
} from "react-icons/fa";

import baseUrl from "../components/baseurl";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${baseUrl}/msgpost`, {
        name: formData.name,
        email: formData.email,
        message: formData.message,
      });

      if (response.status === 200) {
        toast.success("Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          message: "",
        });
      } else {
        toast.error("Failed to send message. Please try again later.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error(
        "An error occurred while sending the message. Please try again later."
      );
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className="bg-indigo-900 w-full min-h-screen">
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">Get In Touch</h2>
            <div className="h-1 w-24 bg-blue-400 mx-auto"></div>
            <p className="text-blue-200 mt-6 max-w-2xl mx-auto">
              I'm always interested in hearing about new projects and
              opportunities. Feel free to reach out if you'd like to connect!
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="space-y-8">
              <div className="bg-indigo-800 bg-opacity-50 p-8 rounded-2xl backdrop-blur-sm shadow-lg">
                <h3 className="text-2xl font-bold text-white mb-6">
                  Contact Information
                </h3>

                <div className="space-y-6">
                  <a
                    href="tel:+2348063399734"
                    className="flex items-center text-blue-200 hover:text-white transition-colors duration-300"
                  >
                    <div className="h-12 w-12 rounded-full bg-blue-600 flex items-center justify-center mr-4 shadow-md">
                      <MdPhone className="h-6 w-6" />
                    </div>
                    <div>
                      <p className="font-medium text-lg">Phone</p>
                      <p className="text-blue-300">+234 806 339 9734</p>
                    </div>
                  </a>

                  <a
                    href="mailto:isadeoye02@gmail.com?subject=Mail from Portfolio"
                    className="flex items-center text-blue-200 hover:text-white transition-colors duration-300"
                  >
                    <div className="h-12 w-12 rounded-full bg-blue-600 flex items-center justify-center mr-4 shadow-md">
                      <MdEmail className="h-6 w-6" />
                    </div>
                    <div>
                      <p className="font-medium text-lg">Email</p>
                      <p className="text-blue-300">isadeoye02@gmail.com</p>
                    </div>
                  </a>

                  <div className="flex items-center text-blue-200">
                    <div className="h-12 w-12 rounded-full bg-blue-600 flex items-center justify-center mr-4 shadow-md">
                      <MdLocationOn className="h-6 w-6" />
                    </div>
                    <div>
                      <p className="font-medium text-lg">Location</p>
                      <p className="text-blue-300">Lagos, Nigeria</p>
                    </div>
                  </div>
                </div>

                <div className="mt-10">
                  <h4 className="text-lg font-medium text-white mb-4">
                    Connect with me
                  </h4>
                  <div className="flex space-x-4">
                    <a
                      href="https://twitter.com/ayoadeoye01"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="h-10 w-10 rounded-full bg-blue-600 hover:bg-blue-500 flex items-center justify-center text-white transition-colors duration-300 shadow-md"
                    >
                      <FaTwitter className="h-5 w-5" />
                    </a>
                    <a
                      href="https://facebook.com/ayobamiisaac.diadem"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="h-10 w-10 rounded-full bg-blue-600 hover:bg-blue-500 flex items-center justify-center text-white transition-colors duration-300 shadow-md"
                    >
                      <FaFacebook className="h-5 w-5" />
                    </a>
                    <a
                      href="https://wa.me/2348063399734"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="h-10 w-10 rounded-full bg-blue-600 hover:bg-blue-500 flex items-center justify-center text-white transition-colors duration-300 shadow-md"
                    >
                      <FaWhatsapp className="h-5 w-5" />
                    </a>
                    <a
                      href="https://github.com/yourusername"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="h-10 w-10 rounded-full bg-blue-600 hover:bg-blue-500 flex items-center justify-center text-white transition-colors duration-300 shadow-md"
                    >
                      <FaGithub className="h-5 w-5" />
                    </a>
                    <a
                      href="https://linkedin.com/in/yourusername"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="h-10 w-10 rounded-full bg-blue-600 hover:bg-blue-500 flex items-center justify-center text-white transition-colors duration-300 shadow-md"
                    >
                      <FaLinkedin className="h-5 w-5" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
    
            <div className="bg-white bg-opacity-10 backdrop-blur-sm p-8 rounded-2xl shadow-lg">
              <h3 className="text-2xl font-bold text-white mb-6">
                Send a Message
              </h3>
              <ToastContainer position="top-right" theme="colored" />
              <form className="space-y-6" onSubmit={handleSubmit}>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <MdPerson className="text-blue-400" size={20} />
                  </div>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your name"
                    className="w-full pl-10 pr-3 py-3 bg-indigo-800 bg-opacity-50 border border-blue-400 rounded-lg text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <MdEmail className="text-blue-400" size={20} />
                  </div>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Your email"
                    className="w-full pl-10 pr-3 py-3 bg-indigo-800 bg-opacity-50 border border-blue-400 rounded-lg text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                <div className="relative">
                  <div className="absolute top-3 left-3 pointer-events-none">
                    <MdMessage className="text-blue-400" size={20} />
                  </div>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Your message"
                    rows="5"
                    className="w-full pl-10 pr-3 py-3 bg-indigo-800 bg-opacity-50 border border-blue-400 rounded-lg text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-blue-600 hover:bg-blue-500 text-white font-medium py-3 px-4 rounded-lg transition-colors duration-300 shadow-md flex items-center justify-center"
                >
                  {isSubmitting ? (
                    <>
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Sending...
                    </>
                  ) : (
                    <>
                      Send Message <MdSend size={20} className="ml-2" />
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center text-blue-200">
          <p>
            &copy; {new Date().getFullYear()} Ayobami Adeoye. All rights
            reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
